/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

import { getProperty } from "trux"

export const getPlayerEmail = (player) => {
    let maskedEmail = getProperty("user.masked_email", player, null)
    let fullEmail = getProperty("user.email", player, null)

    if (fullEmail) {
        return fullEmail
    }
    if (maskedEmail) {
        return maskedEmail
    }
    return "someone@someplace.com"
}
